import React from "react";

class ApMobileHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const addAnnotationMode = this.props.addAnnotationMode === true;

    if (!addAnnotationMode)
      return (
        <div className="ApMobileHeader">
          <div id="Cell" style={{ textAlign: "left" }}>
            <Button
              onClick={() => this.props.onButton("approve_panel")}
              color="Approve"
              alt="Approve"
              src={require("../../../media/icons/check-solid.svg")}
            />
            <div className="Spacer-HB" />
            <Button
              onClick={() => this.props.onButton("reject_panel")}
              alt="Reject"
              src={require("../../../media/icons/times-solid.svg")}
            />
          </div>
          <div id="Cell">
            <Button
              onClick={() => this.props.onButton("add_annotation_panel")}
              alt="Add Annotation"
              src={require("../../../media/icons/plus-solid.svg")}
            />
          </div>
          <div id="Cell" style={{ textAlign: "right" }}>
            <Button
              onClick={() => this.props.onButton("annotations_panel")}
              alt="Annotations"
              src={require("../../../media/icons/clipboard-list-solid.svg")}
            />
            <div className="Spacer-HB" />
            <Button
              onClick={() => this.props.onButton("sidebar")}
              alt="Menu"
              src={require("../../../media/icons/folder-open-solid.svg")}
            />
          </div>
        </div>
      );
    else {
      const { addAnnotationType } = this.props;
      return (
        <div className="ApMobileHeader ApMobileHeader-EditMode">
          <div id="Cell" style={{ textAlign: "left" }}>
            <Button
              onClick={() => this.props.onButton("add_annotation_dismiss")}
              color="Approve"
              alt="Approve"
              src={require("../../../media/icons/arrow-left-solid.svg")}
            />
          </div>
          <div id="Cell">
            <strong>Anmerkung Hinzufügen</strong>
          </div>
          <div id="Cell">
            <p>{addAnnotationType === "point" ? "Punkt" : "Fläche"}</p>
          </div>
        </div>
      );
    }
  }
}

function Button(props) {
  return (
    <div
      className={
        "ApMobileHeaderIconButton" +
        (props.color ? " ApMobileColor-" + props.color : "")
      }
      onClick={() => props.onClick()}
    >
      <img src={props.src} alt={props.alt} className="ApMobileRoundBtn" />
    </div>
  );
}

export default ApMobileHeader;



// WEBPACK FOOTER //
// ./src/components/approval/mobile/ApMobileHeader.js